import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE/HEALTH';

export const {action: toggleEdit} = createAction(`${domain}/TOGGLE_EDIT`, edit => ({edit}));

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(
    `${domain}/UPDATE`,
    (childId, health, updateToken, rawFormData) => ({childId, health, updateToken, rawFormData}),
    (childId, rawFormData) => ({childId, rawFormData}),
);

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
    aborted: fetchAborted,
} = createAction(
    `${domain}/FETCH`,
    (childId, needsPassword) => ({childId, needsPassword}),
    (health, updateToken) => ({health, updateToken}),
);

export const {action: exit} = createAction(`${domain}/EXIT`, () => ({}));
